import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-az-input',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './az-input.component.html',
  styleUrls: ['./az-input.component.scss'],
})
export class AzInputComponent {
  @Input() value = '';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() type: 'text' | 'email' | 'tel' | 'number' = 'text';
  @Output() valueChange = new EventEmitter<string>();

  onInputChange(value: string): void {
    this.valueChange.emit(value);
  }
}
